<template>
  <div :load="doInit">
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> {{ labels.dateRangeTitle }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md6 lg6>
                          <v-autocomplete
                            :items="renewalNoticeTypeList"
                            v-model="filters.renewalNoticeType"
                            :label="labels.renewalNoticeType"
                            item-text="label"
                            item-value="value"
                            data-vv-name="renewalNoticeType"
                            :data-vv-as="labels.renewalNoticeType"
                            :error-messages="errors.collect('renewalNoticeType')"
                            v-validate="'required'"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6> </v-flex>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker
                            v-model="filters.expDateFr"
                            :label="labels.expDateFr"
                            :error-messages="errors.collect('expDateFr')"
                            data-vv-name="expDateFr"
                            :data-vv-as="labels.expDateFr"
                            v-validate="'required'"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker
                            v-model="filters.expDateTo"
                            :label="labels.expDateTo"
                            :error-messages="errors.collect('expDateTo')"
                            data-vv-name="expDateTo"
                            :data-vv-as="labels.expDateTo"
                            v-validate="valExpDateTo"
                          ></cal-picker>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> {{ labels.filters }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <!-- Direct / RI Inwards -->
                        <v-flex xs12 sm6 md6 lg6>
                          <v-autocomplete
                            :items="dRiList"
                            v-model="filters.dRi"
                            :label="labels.dRi"
                            item-text="label"
                            item-value="value"
                            data-vv-name="dRi"
                            :data-vv-as="labels.dRi"
                            :error-messages="errors.collect('dRi')"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6></v-flex>

                        <!-- Policy No. From -->
                        <v-flex xs12 sm6 md6 lg6>
                          <v-text-field
                            ref="polNoFr"
                            v-model="filters.polNoFr"
                            :label="labels.polNoFr"
                            :error-messages="errors.collect('polNoFr')"
                            data-vv-name="polNoFr"
                            :data-vv-as="labels.polNoFr"
                            v-validate="valPolNoFr"
                            @change="doValPolNoFr"
                            :loading="polNoFrLoading"
                            clearable
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon color="info" @click="doPolNoFr" v-text="'mdi-magnify'"></v-icon>
                            </v-slide-x-reverse-transition>
                          </v-text-field>
                        </v-flex>
                        <!-- Policy No. To -->
                        <v-flex xs12 sm6 md6 lg6>
                          <v-text-field
                            ref="polNoTo"
                            v-model="filters.polNoTo"
                            :label="labels.polNoTo"
                            :error-messages="errors.collect('polNoTo')"
                            data-vv-name="polNoTo"
                            :data-vv-as="labels.polNoTo"
                            v-validate="valPolNoTo"
                            @change="doValPolNoTo"
                            :loading="polNoToLoading"
                            clearable
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon color="info" @click="doPolNoTo" v-text="'mdi-magnify'"></v-icon>
                            </v-slide-x-reverse-transition>
                          </v-text-field>
                        </v-flex>
                        <!-- Agent From -->
                        <v-flex xs12 sm6 md6 lg6>
                          <v-autocomplete
                            :items="billAcctNoList"
                            v-model="filters.agentFr"
                            :label="labels.agentFr"
                            item-text="label"
                            item-value="value"
                            data-vv-name="agentFr"
                            :data-vv-as="labels.agentFr"
                            :error-messages="errors.collect('agentFr')"
                            v-validate="valAgentFr"
                            @change="doAgentFr"
                            clearable
                            :disabled="disableAgentFrTo"
                          ></v-autocomplete>
                        </v-flex>

                        <!-- Agent To -->
                        <v-flex xs12 sm6 md6 lg6>
                          <v-autocomplete
                            :items="billAcctNoList"
                            v-model="filters.agentTo"
                            :label="labels.agentTo"
                            item-text="label"
                            item-value="value"
                            data-vv-name="agentTo"
                            :data-vv-as="labels.agentTo"
                            :error-messages="errors.collect('agentTo')"
                            v-validate="valAgentTo"
                            @change="doAgentTo"
                            clearable
                            :disabled="disableAgentFrTo"
                          ></v-autocomplete>
                        </v-flex>

                        <!-- Branch -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            readonly
                            v-model="filters.branch"
                            :label="labels.branch"
                            :error-messages="errors.collect('branch')"
                            data-vv-name="branch"
                            :data-vv-as="labels.branch"
                            append-icon="mdi-magnify"
                            @click:append="multiBranchList = true"
                          ></v-text-field>
                        </v-flex>

                        <!-- Department -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            readonly
                            v-model="filters.dept"
                            :label="labels.dept"
                            :error-messages="errors.collect('dept')"
                            :data-vv-as="labels.dept"
                            data-vv-name="dept"
                            append-icon="mdi-magnify"
                            @click:append="multiDeptList = true"
                          ></v-text-field>
                        </v-flex>

                        <!-- Policy Type -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            v-model="filters.polType"
                            :label="labels.polType"
                            :error-messages="errors.collect('polType')"
                            :data-vv-as="labels.polType"
                            data-vv-name="polType"
                            append-icon="mdi-magnify"
                            @click:append="multiPolTypeList = true"
                            readonly
                            v-validate="'required'"
                          ></v-text-field>
                        </v-flex>

                        <!-- Policy Status -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            v-model="filters.polStat"
                            :label="labels.polStat"
                            :error-messages="errors.collect('polStat')"
                            :data-vv-as="labels.polStat"
                            data-vv-name="polStat"
                            append-icon="mdi-magnify"
                            @click:append="multiPolStatList = true"
                            readonly
                            v-validate="'required'"
                          ></v-text-field>
                        </v-flex>

                        <!-- Client Type -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            readonly
                            v-model="filters.clientType"
                            :label="labels.clientType"
                            :error-messages="errors.collect('clientType')"
                            :data-vv-as="labels.clientType"
                            data-vv-name="clientType"
                            append-icon="mdi-magnify"
                            @click:append="multiClientTypeList = true"
                          ></v-text-field>
                        </v-flex>

                        <!-- Account Type -->
                        <!-- KIV -->

                        <!-- Agent -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            readonly
                            v-model="filters.agent"
                            :label="labels.agent"
                            :error-messages="errors.collect('agent')"
                            :data-vv-as="labels.agent"
                            data-vv-name="agent"
                            append-icon="mdi-magnify"
                            @click:append="multiInterList = true"
                            :disabled="disableAgent"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>

        <v-flex xs12>
          <v-expansion-panels v-model="panel3" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> {{ labels.printSetting }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <!--Print Sequence -->
                        <v-flex xs12 sm6 md6 lg6>
                          <v-autocomplete
                            :items="printSeqList"
                            v-model="filters.printSeq"
                            :label="labels.printSeq"
                            item-text="label"
                            item-value="value"
                            data-vv-name="printSeq"
                            :data-vv-as="labels.printSeq"
                            :error-messages="errors.collect('printSeq')"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6></v-flex>

                        <!-- No. of copies -->
                        <v-flex xs12 sm6 md6 lg6>
                          <v-text-field
                            v-model="filters.copy"
                            :label="labels.copy"
                            :error-messages="errors.collect('copy')"
                            data-vv-name="copy"
                            :data-vv-as="labels.copy"
                            v-validate="'required|numeric|min_value:1|max_value:10'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6></v-flex>

                        <!-- Exclude if Renewal Notice already printed -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-checkbox
                            v-model="filters.excRenNot"
                            :label="labels.excRenNot"
                            :error-messages="errors.collect('excRenNot')"
                            data-vv-name="excRenNot"
                            :data-vv-as="labels.excRenNot"
                          ></v-checkbox>
                        </v-flex>

                        <!-- Report policies that have been renewed -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-checkbox
                            v-model="filters.rptRenewPolicy"
                            :label="labels.rptRenewPolicy"
                            :error-messages="errors.collect('rptRenewPolicy')"
                            data-vv-name="rptRenewPolicy"
                            :data-vv-as="labels.rptRenewPolicy"
                          ></v-checkbox>
                        </v-flex>

                        <!-- Print Agent’s name and address -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-checkbox
                            v-model="filters.prtAgentNameAddr"
                            :label="labels.prtAgentNameAddr"
                            :error-messages="errors.collect('prtAgentNameAddr')"
                            data-vv-name="prtAgentNameAddr"
                            :data-vv-as="labels.prtAgentNameAddr"
                          ></v-checkbox>
                        </v-flex>

                        <!-- Print list of printed renewal notices -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-checkbox
                            v-model="filters.prtRenNotList"
                            :label="labels.prtRenNotList"
                            :error-messages="errors.collect('prtRenNotList')"
                            data-vv-name="prtRenNotList"
                            :data-vv-as="labels.prtRenNotList"
                          ></v-checkbox>
                        </v-flex>

                        <!-- Print outstanding premium -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-checkbox
                            v-model="filters.prtOSPrem"
                            :label="labels.prtOSPrem"
                            :error-messages="errors.collect('prtOSPrem')"
                            data-vv-name="prtOSPrem"
                            :data-vv-as="labels.prtOSPrem"
                          ></v-checkbox>
                        </v-flex>

                        <!-- Print claim no. / loss date -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-checkbox
                            v-model="filters.prtClmLossDate"
                            :label="labels.prtClmLossDate"
                            :error-messages="errors.collect('prtClmLossDate')"
                            data-vv-name="prtClmLossDate"
                            :data-vv-as="labels.prtClmLossDate"
                          ></v-checkbox>
                        </v-flex>

                        <!-- Print claim information -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-checkbox
                            v-model="filters.prtClmInfo"
                            :label="labels.prtClmInfo"
                            :error-messages="errors.collect('prtClmInfo')"
                            data-vv-name="prtClmInfo"
                            :data-vv-as="labels.prtClmInfo"
                          ></v-checkbox>
                        </v-flex>

                        <!-- Print insured address from insured master -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-checkbox
                            v-model="filters.prtInsdAddr"
                            :label="labels.prtInsdAddr"
                            :error-messages="errors.collect('prtInsdAddr')"
                            data-vv-name="prtInsdAddr"
                            :data-vv-as="labels.prtInsdAddr"
                          ></v-checkbox>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12 class="pt-3">
          <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
            {{ labels.export }}
          </v-btn>
          <v-btn-toggle dense mandatory>
            <v-btn text>
              <span>{{ labels.format }}</span>
              <v-icon :color="'red'">mdi-file-pdf</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="submitting" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-3">
          Processing...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showErrorDialog" width="800px">
      <v-card>
        <v-card-title primary-title>
          <div>
            <div class="headline">System Information</div>
            <span class="grey--text">An error occurred.</span>
          </div>
        </v-card-title>
        <v-card-text>
          <div v-if="messages.length > 0" class="pb-3">
            <v-subheader>Error Details:</v-subheader>
            <ul class="showErrorMsgs">
              <li v-for="(error, index) in messages" :key="index">
                {{ error.message }}
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showPolicyHelpList" width="1280px" persistent>
      <policy-help-list-by-expiry-date-range
        ref="PolicyHelpListByExpiryDateRange"
        @close="showPolicyHelpList = false"
        :apiURI="this.menu.policyList"
        :expDateFr="this.filters.expDateFr"
        :expDateTo="this.filters.expDateTo"
        @assign-policy="assignPolicy"
      ></policy-help-list-by-expiry-date-range>
    </v-dialog>

    <v-dialog v-model="multiBranchList" width="900px" persistent>
      <multi-branch-help-list :brn="filters.branch" @close="doClose" @doAssign="doAssignBranch($event)"></multi-branch-help-list>
    </v-dialog>

    <v-dialog v-model="multiDeptList" width="900px" persistent>
      <multi-dept-help-list :dept="filters.dept" @close="doClose" @doAssign="doAssignDepartment($event)"></multi-dept-help-list>
    </v-dialog>

    <v-dialog v-model="multiPolTypeList" width="900px" persistent>
      <multi-pol-type-help-list :pt="filters.polType" @close="doClose" @doAssign="doAssignPolType($event)"></multi-pol-type-help-list>
    </v-dialog>

    <v-dialog v-model="multiPolStatList" width="900px" persistent>
      <multi-pol-stat-help-list :polStat="filters.polStat" @close="doClose" @doAssign="doAssignPolStat($event)"></multi-pol-stat-help-list>
    </v-dialog>

    <v-dialog v-model="multiClientTypeList" width="900px" persistent>
      <multi-client-type-help-list
        :clientType="filters.clientType"
        @close="doClose"
        @doAssign="doAssignClientType($event)"
      ></multi-client-type-help-list>
    </v-dialog>

    <v-dialog v-model="multiInterList" width="900px" persistent>
      <multi-intermediary-help-list
        :intr="filters.agent"
        intrGrp="10,11,25"
        helpListTitle="Agent HelpList"
        @close="doClose"
        @doAssign="doAssignIntermediary($event)"
      ></multi-intermediary-help-list>
    </v-dialog>
  </div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { reportFormat } from '@/const/report'
import MultiPolTypeHelpList from '@/components/core/common/dialog/MultiPolTypeHelpList'
import MultiBranchHelpList from '@/components/core/common/dialog/MultiBranchHelpList'
import MultiDeptHelpList from '@/components/core/common/dialog/MultiDeptHelpList.vue'
import MultiPolStatHelpList from '@/components/core/common/dialog/MultiPolStatHelpList'
import MultiClientTypeHelpList from '@/components/core/common/dialog/MultiClientTypeHelpList.vue'
import PolicyHelpListByExpiryDateRange from '@/components/core/common/dialog/PolicyHelpListByExpiryDateRange'
import MultiIntermediaryHelpList from '@/components/core/common/dialog/MultiIntermediaryHelpList.vue'

export default {
  data() {
    return {
      labels: {
        dateRangeTitle: 'Date Ranges',
        renewalNoticeType: 'Renewal Notice Type',
        expDateFr: 'Expiry Date From',
        expDateTo: 'Expiry Date To',
        filters: 'Filters',
        dRi: 'Direct / RI Inwards',
        polNoFr: 'Policy No. From',
        polNoTo: 'Policy No. To',
        agentFr: 'Agent From',
        agentTo: 'Agent To',
        export: 'Export To',
        branch: 'Branch',
        dept: 'Department',
        polType: 'Policy Type',
        polStat: 'Policy Status',
        clientType: 'Client Type',
        agent: 'Agent',
        printSetting: 'Print Settings',
        printSeq: 'Print Sequence',
        copy: 'No. of copies',
        excRenNot: 'Exclude if Renewal Notice already printed',
        rptRenewPolicy: 'Report policies that have been renewed',
        prtAgentNameAddr: 'Print Agent’s name and address',
        prtRenNotList: 'Print list of printed renewal notices',
        prtOSPrem: 'Print outstanding premium',
        prtClmLossDate: 'Print claim no. / loss date',
        prtClmInfo: 'Print claim information',
        prtInsdAddr: 'Print insured address from insured master',
        format: 'PDF'
      },
      filters: {
        renewalNoticeType: 'F',
        expDateFr: new Date(),
        expDateTo: new Date(),
        dRi: 'All',
        polNoFr: null,
        polNoTo: null,
        agentFr: null,
        agentTo: null,
        branch: 'All',
        dept: 'All',
        polType: 'All',
        polStat: 'All',
        clientType: 'All',
        agent: 'All',
        printSeq: '01',
        copy: 1,
        excRenNot: false,
        rptRenewPolicy: true,
        prtAgentNameAddr: true,
        prtRenNotList: true,
        prtOSPrem: true,
        prtClmLossDate: true,
        prtClmInfo: true,
        prtInsdAddr: false,
        format: 'PDF'
      },
      error: {
        polNoFr: null,
        polNoTo: null,
        agentFr: null,
        agentTo: null
      },
      polNoHelp: null,
      polNoFrLoading: false,
      polNoToLoading: false,
      renewalNoticeTypeList: [
        { label: 'First Notice', value: 'F' },
        { label: 'Reminder', value: 'R' }
      ],
      dRiList: [
        {
          label: 'All',
          value: 'All'
        },
        {
          label: 'Direct',
          value: 'D'
        },
        {
          label: 'RI Inwards',
          value: 'R'
        }
      ],
      printSeqList: [
        {
          label: 'Policy No.',
          value: '01'
        },
        {
          label: 'Agent Ref.',
          value: '02'
        }
      ],
      showPolicyHelpList: false,
      menu: {},
      menu2: {},
      billAcctNoList: [],
      supportedFormat: [],
      submitting: false,
      showErrorDialog: false,
      multiPolTypeList: false,
      multiBranchList: false,
      multiDeptList: false,
      multiPolStatList: false,
      multiClientTypeList: false,
      multiInterList: false,
      panel1: [0],
      panel2: [0],
      panel3: [0]
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    displayErrorDialog() {
      return this.messages
    },
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    valExpDateTo() {
      if (this.filters.expDateFr !== undefined && this.filters.expDateFr !== null && this.filters.expDateFr !== '') {
        return 'required|start_enddate:' + this.filters.expDateFr
      } else {
        return 'required'
      }
    },
    valPolNoFr() {
      if (
        this.filters.polNoTo !== null &&
        this.filters.polNoTo !== undefined &&
        this.filters.polNoTo !== '' &&
        (this.filters.polNoFr === null || this.filters.polNoFr === undefined || this.filters.polNoFr === '')
      ) {
        return 'required'
      } else if (this.error.polNoFr !== null) {
        return 'valField:' + this.error.polNoFr
      } else {
        return ''
      }
    },
    valPolNoTo() {
      if (
        this.filters.polNoFr !== null &&
        this.filters.polNoFr !== undefined &&
        this.filters.polNoFr !== '' &&
        (this.filters.polNoTo === null || this.filters.polNoTo === undefined || this.filters.polNoTo === '')
      ) {
        return 'required'
      } else if (this.error.polNoTo !== null) {
        return 'valField:' + this.error.polNoTo
      } else {
        return ''
      }
    },
    valAgentFr() {
      if (
        this.filters.agentTo !== null &&
        this.filters.agentTo !== undefined &&
        this.filters.agentTo !== '' &&
        (this.filters.agentFr === null || this.filters.agentFr === undefined || this.filters.agentFr === '')
      ) {
        return 'required'
      } else if (this.error.agentFr !== null) {
        return 'valField:' + this.error.agentFr
      } else {
        return ''
      }
    },
    valAgentTo() {
      if (
        this.filters.agentFr !== null &&
        this.filters.agentFr !== undefined &&
        this.filters.agentFr !== '' &&
        (this.filters.agentTo === null || this.filters.agentTo === undefined || this.filters.agentTo === '')
      ) {
        return 'required'
      } else if (this.error.agentTo !== null) {
        return 'valField:' + this.error.agentTo
      } else {
        return ''
      }
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    disableExcRenNot() {
      if (this.filters.renewalNoticeType === 'F') {
        return true
      } else {
        return false
      }
    },
    disableAgentFrTo() {
      if (this.filters.agent !== 'All') {
        return true
      } else {
        return false
      }
    },
    disableAgent() {
      if (
        (this.filters.agentFr !== null && this.filters.agentFr !== undefined) ||
        (this.filters.agentTo !== null && this.filters.agentTo !== undefined)
      ) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    async doInit() {
      // this.doRenewalNoticeType()

      if (this.$store.state.reports.uwReports.init !== 1) {
        await this.$store.dispatch('uwReportsInit')
      }

      this.getCommonDataList2('billAcctNoList')

      const apiURI = this.rptMenu.initRenScrutinyList
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          if (result.data) {
            const { data } = result.data
            if (data) {
              this.supportedFormat = data.format
              this.menu = extractMenu(result.data._links)
            }
          }
        } catch (err) {
          throw err
        }
      }

      const apiURI2 = this.rptMenu.initRenewalNotice
      if (apiURI2) {
        try {
          const result = await this.$http.get(apiURI2)
          if (result.data) {
            const { data } = result.data
            if (data) {
              this.supportedFormat = data.format
              this.menu2 = extractMenu(result.data._links)
            }
          }
        } catch (err) {
          throw err
        }
      }
    },
    doPolNoFr() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.polNoHelp = 1
          this.showPolicyHelpList = true
          if (this.$refs.PolicyHelpListByExpiryDateRange) {
            this.$refs.PolicyHelpListByExpiryDateRange.fetchPolicyData()
          }
        }
      })
    },
    doPolNoTo() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.polNoHelp = 2
          this.showPolicyHelpList = true
          if (this.$refs.PolicyHelpListByExpiryDateRange) {
            this.$refs.PolicyHelpListByExpiryDateRange.fetchPolicyData()
          }
        }
      })
    },
    assignPolicy(data) {
      if (this.polNoHelp === 1) {
        this.filters.polNoFr = data.polNo
        this.doValPolNoFr().then(() => {
          if (this.filters.polNoTo === '' || this.filters.polNoTo === undefined || this.filters.polNoTo === null) {
            this.filters.polNoTo = data.polNo
            this.doValPolNoTo()
          }
        })
      } else {
        this.filters.polNoTo = data.polNo
        this.doValPolNoTo()
      }

      this.showPolicyHelpList = false
    },
    async doValPolNoFr() {
      const result2 = await this.$validator.validateAll()
      if (result2) {
        if (this.filters.polNoFr !== null && this.filters.polNoFr !== undefined && this.filters.polNoFr !== '') {
          const apiUrl = this.menu.valPolNo
          if (apiUrl) {
            try {
              this.polNoFrLoading = true
              const expand = {
                polNo: this.filters.polNoFr
              }
              const result = await this.$http.get(expandURI(apiUrl, expand))
              if (result.data) {
                this.error.polNoFr = null
                this.polNoFrLoading = false
              }
            } catch (err) {
              const { data } = err.response
              if (data) {
                if (data.messages.length > 0) {
                  this.error.polNoFr = data.messages[0].message
                  this.$refs.polNoFr.focus()
                }
              }
              this.polNoFrLoading = false
            }
          } else {
            this.$toast.error('The request failed because it is trying to execute an invalid API url.')
          }
        }
      } else if (
        this.filters.expDateFr === undefined ||
        this.filters.expDateFr === null ||
        this.filters.expDateFr === '' ||
        this.filters.expDateTo === undefined ||
        this.filters.expDateTo === null ||
        this.filters.expDateTo === ''
      ) {
        this.filters.polNoFr = ''
      }
    },
    async doValPolNoTo() {
      const result2 = await this.$validator.validateAll()
      if (result2) {
        if (this.filters.polNoTo !== null && this.filters.polNoTo !== undefined && this.filters.polNoTo !== '') {
          if (this.filters.polNoTo < this.filters.polNoFr) {
            this.error.polNoTo = 'Cannot be less than Policy No. From value (20193)'
          } else {
            const apiUrl = this.menu.valPolNo
            if (apiUrl) {
              try {
                this.polNoToLoading = true
                const expand = {
                  polNo: this.filters.polNoTo
                }
                const result = await this.$http.get(expandURI(apiUrl, expand))
                if (result.data) {
                  this.error.polNoTo = null
                  this.polNoToLoading = false
                }
              } catch (err) {
                const { data } = err.response
                if (data) {
                  if (data.messages.length > 0) {
                    this.error.polNoTo = data.messages[0].message
                    this.$refs.polNoTo.focus()
                  }
                }
                this.polNoToLoading = false
              }
            } else {
              this.$toast.error('The request failed because it is trying to execute an invalid API url.')
            }
          }
        }
      } else if (
        this.filters.expDateFr === undefined ||
        this.filters.expDateFr === null ||
        this.filters.expDateFr === '' ||
        this.filters.expDateTo === undefined ||
        this.filters.expDateTo === null ||
        this.filters.expDateTo === ''
      ) {
        this.filters.polNoTo = ''
      }
    },
    doAgentFr() {
      if (
        this.filters.agentFr !== null &&
        this.filters.agentFr !== undefined &&
        this.filters.agentFr !== '' &&
        (this.filters.agentTo === null || this.filters.agentTo === undefined || this.filters.agentTo === '')
      ) {
        this.filters.agentTo = this.filters.agentFr
      } else {
        this.doAgentTo()
      }
    },
    doAgentTo() {
      if (
        this.filters.agentFr !== null &&
        this.filters.agentFr !== undefined &&
        this.filters.agentFr !== '' &&
        this.filters.agentTo !== null &&
        this.filters.agentTo !== undefined &&
        this.filters.agentTo !== ''
      ) {
        if (this.filters.agentTo < this.filters.agentFr) {
          this.error.agentTo = 'Must be equal to or greater than FROM value values (20048)'
        } else {
          this.error.agentTo = null
        }
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiUrl = this.menu2.generateRenewalNotice
      if (apiUrl) {
        try {
          this.submitting = true
          await this.$http.post(apiUrl, this.filters)
          this.$toast.success('Renewal Notice Successfully Submiited.')
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.submitting = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url. [processExport]')
      }
    },
    doAssignBranch(Obj) {
      this.filters.branch = []
      this.filters.branch = Obj.finalSelectedItems.toString()
    },
    async doAssignDepartment(Obj) {
      this.filters.dept = []
      this.filters.dept = Obj.finalSelectedItems.toString()
    },
    async doAssignClientType(Obj) {
      this.filters.clientType = []
      this.filters.clientType = Obj.finalSelectedItems.toString()
    },
    doClose() {
      this.multiPolTypeList = false
      this.multiBranchList = false
      this.multiDeptList = false
      this.multiPolStatList = false
      this.multiClientTypeList = false
      this.multiInterList = false
    },
    doAssignPolType(Obj) {
      this.filters.polType = []
      this.filters.polType = Obj.finalSelectedItems.toString()
    },
    doAssignPolStat(Obj) {
      this.filters.polStat = []
      this.filters.polStat = Obj.finalSelectedItems.toString()
    },
    async doAssignIntermediary(Obj) {
      this.filters.agent = []
      this.filters.agent = Obj.finalSelectedItems.toString()
    },
    doRenewalNoticeType() {
      if (this.filters.renewalNoticeType === 'F') {
        this.filters.excRenNot = false
      } else {
        this.filters.excRenNot = true
      }
    }
  },
  created() {
    this.doInit()

    // Local validator
    const valField = {
      getMessage: (field, args) => {
        if (args === void 0) args = []
        var errMsg = args[0]
        errMsg = errMsg.replace(/%2C/g, ',')
        return errMsg
      },
      validate: (value, args) => {
        if (value) {
          if (args === void 0) args = []
          var errMsg = args[0]
          if (errMsg) {
            return false
          } else return true
        } else return true
      }
    }
    this.$validator.extend('valField', valField)
  },
  mixins: [MessageMixin, commonAjaxMixin],
  components: {
    PolicyHelpListByExpiryDateRange,
    MultiPolTypeHelpList,
    MultiBranchHelpList,
    MultiDeptHelpList,
    MultiClientTypeHelpList,
    MultiPolStatHelpList,
    MultiIntermediaryHelpList
  }
}
</script>

<style>
</style>
